export enum TutorialActions {
  SET_TUTORIAL = 'SET_TUTORIAL',
}
